import { render, staticRenderFns } from "./TwoStep.vue?vue&type=template&id=28cac655&scoped=true&"
import script from "./TwoStep.vue?vue&type=script&lang=js&"
export * from "./TwoStep.vue?vue&type=script&lang=js&"
import style0 from "./TwoStep.vue?vue&type=style&index=0&id=28cac655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cac655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cac655')) {
      api.createRecord('28cac655', component.options)
    } else {
      api.reload('28cac655', component.options)
    }
    module.hot.accept("./TwoStep.vue?vue&type=template&id=28cac655&scoped=true&", function () {
      api.rerender('28cac655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/TwoStep.vue"
export default component.exports